import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RegistrationPage } from '@/pages/RegistrationPage'
import { SuccessPage } from '@/pages/SuccessPage'
import { GalaRsvpPage } from '@/pages/GalaRsvpPage'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
    mutations: {
      retry: 0,
    },
  },
})

export function App() {
  const hostname =
    typeof window === 'undefined' ? '' : window.location.hostname.toLowerCase()
  const isRsvpHost =
    hostname === 'rsvp.yuvapremierleague.in' ||
    hostname.startsWith('rsvp.') ||
    hostname === 'ypl11-rsvp.pages.dev' ||
    hostname.endsWith('.ypl11-rsvp.pages.dev')

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={isRsvpHost ? <GalaRsvpPage /> : <RegistrationPage />} />
          <Route path="/rsvp" element={<GalaRsvpPage />} />
          <Route path="/gala-dinner-rsvp" element={<GalaRsvpPage />} />
          <Route path="/success" element={<SuccessPage />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  )
}
